import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePageTitle } from '../../lib/usePageTitle';
import { AppLayout } from '../../components/AppLayout';
import { TextField } from '../../components/TextField';
import { Button } from '../../components/Button';

/** Inserimento manuale di un codice invito. */
export function EnterCodePage() {
  usePageTitle('Entra con un codice');
  const navigate = useNavigate();
  const [code, setCode] = useState('');
  const [error, setError] = useState<string | undefined>(undefined);

  const submit = () => {
    const clean = code.trim().toUpperCase();
    if (clean.length < 4) {
      setError('Inserisci il codice invito che hai ricevuto (almeno 4 caratteri).');
      return;
    }
    navigate(`/entra/${clean}`);
  };

  return (
    <AppLayout title="Entra con un codice">
      <div className="mt-6 max-w-md">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submit();
          }}
          noValidate
          className="flex flex-col gap-4"
        >
          <TextField
            label="Codice invito"
            description="Il codice che ti è stato condiviso, ad esempio 22UAM23W."
            required
            error={error}
            value={code}
            onChange={(e) => {
              setCode(e.target.value);
              setError(undefined);
            }}
            autoCapitalize="characters"
            autoComplete="off"
            spellCheck={false}
          />
          <Button type="submit">Continua</Button>
        </form>
      </div>
    </AppLayout>
  );
}
